// Language specific routes
import fi from './fi'

export const routes = {
  fi
}
